import React, { Component } from "react";
import { connect } from "react-redux";

import "../scss/login.scss";

import SendRequestButton from "../containers/SendRequestButton"
import { setUser } from "../actions/siteActions";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        username: "",
        password: "",
        userNiceName: "",
        userEmail: "",
        loggedIn: false,
        loading: false,
        error: "",
      },
    };
  }
  onFormSubmit = (event) => {
    event.preventDefault();
    const siteUrl = "https://eestipagar.ee/ep_catalog/wp-json";
    //const siteUrl = "http://ep_catalog.localhost/index.php/wp-json";

    const loginData = {
      username: this.state.user.username,
      password: this.state.user.password,
    };
    var formData = new FormData();
    formData.append("username", this.state.user.username);
    formData.append("password", this.state.user.password);

    this.setState((prevState) => ({
      user: { ...prevState.user, loading: true },
    }));
    fetch(`${siteUrl}/jwt-auth/v1/token`, {
      body: formData,
      method: "POST",
    })
      .then((response) => response.json())
      .then((response) => {
        //console.log("Result:", response);

     /* if(response.code){
        console.log("error ? ", response.message);
        return;
      }*/

        if (response.data && response.data.status) {
          this.setState((prevState) => ({
            user: {
              ...prevState.user,
              error: response.message,
              loading: false,
            },
          }));
          return;
        }
        localStorage.setItem("token", response.token);
        localStorage.setItem("userName", response.user_nicename);

        this.setState((prevState) => ({
          user: {
            ...prevState.user,
            loading: false,
            token: response.token,
            userNiceName: response.user_nicename,
            userDisplayName: response.user_display_name,
            userEmail: response.user_email,
            loggedIn: true,
            error: ''
          },
        }));
        this.props.setUser(this.state.user);
      
      })
      .catch((error) => {
        console.error("Error:", error);
        this.setState((prevState) => ({
          user: { ...prevState.user, error: error.data, loading: false },
        }));
      });
  };
  
  openSendRequestForm = () =>{
   // console.log("asdasdasd")
  }


  handleOnChange = (event) => {
    const { name, value } = event.target; // <-- moved outside asynchronous context
   // console.log(name);
    this.setState(
      (prevState) => ({
        user: { ...prevState.user, [name]: value },
      }),
    //  console.log(this.state.user[name])
    );
  };

  render() {
    const { user } = this.state;
    const { site } = this.props;
    return (
      <div className="login">
        <form onSubmit={this.onFormSubmit}>
          <label>
            Kasutaja:
            <input
              type="text"
              name="username"
              value={user.username}
              onChange={this.handleOnChange}
            />
          </label>
          <label>
            Parool:
            <input
              type="password"
              name="password"
              value={user.password}
              onChange={this.handleOnChange}
            />
          </label>
          <button type="submit" className="button primary">Logi sisse</button>
          <SendRequestButton /> 
          
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  site: state.site,
});

export default connect(mapStateToProps, { setUser })(Login);
